var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup98(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "white",
    stroke: "#1BABE2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7501 28.5H30.9167V30.3125H35.7501V28.5Z",
    fill: "#1BABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7501 32.125H30.9167V33.9375H35.7501V32.125Z",
    fill: "#1BABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1667 22.4583H32.1251V18.8333C32.1251 17.5041 31.0376 16.4166 29.7084 16.4166H27.2917C25.9626 16.4166 24.8751 17.5041 24.8751 18.8333V22.4583H18.8334C17.5042 22.4583 16.4167 23.5458 16.4167 24.875V38.1666C16.4167 39.4958 17.5042 40.5833 18.8334 40.5833H38.1667C39.4959 40.5833 40.5834 39.4958 40.5834 38.1666V24.875C40.5834 23.5458 39.4959 22.4583 38.1667 22.4583ZM27.2917 22.4583V18.8333H29.7084V22.4583V24.875H27.2917V22.4583ZM38.1667 38.1666H18.8334V24.875H24.8751C24.8751 26.2041 25.9626 27.2916 27.2917 27.2916H29.7084C31.0376 27.2916 32.1251 26.2041 32.1251 24.875H38.1667V38.1666Z",
    fill: "#1BABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 32.125C25.876 32.125 26.6875 31.3135 26.6875 30.3125C26.6875 29.3115 25.876 28.5 24.875 28.5C23.874 28.5 23.0625 29.3115 23.0625 30.3125C23.0625 31.3135 23.874 32.125 24.875 32.125Z",
    fill: "#1BABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3883 33.5508C26.615 33.2125 25.7692 33.0312 24.875 33.0312C23.9808 33.0312 23.135 33.2125 22.3617 33.5508C21.685 33.8408 21.25 34.4933 21.25 35.2304V35.75H28.5V35.2304C28.5 34.4933 28.065 33.8408 27.3883 33.5508Z",
    fill: "#1BABE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup98);
export default __webpack_public_path__ + "static/media/Group98.98dcc5f9.svg";
export { ForwardRef as ReactComponent };